import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { IncludesSection } from './IncludesSection';
import { BenefitsSection } from './BenefitsSection';
import { PreviewCarouselSection } from './PreviewCarouselSection';
import { TestimonialsSection } from './TestimonialsSection';
import { BonusSection } from './BonusSection';
import { PricingSection } from './PricingSection';
import { FAQSection } from './FAQSection';
import { PurchasePopup } from './PurchasePopup';
import { useMetaPixel } from '../hooks/useMetaPixel';
const META_PIXEL_ID = '1904779843432668';
export function LandingPage() {
  useMetaPixel(META_PIXEL_ID);
  return <main className="min-h-screen bg-[#FDF6E3] font-sans text-gray-900" data-id="element-110">
      <HeroSection data-id="element-111" />
      <ProblemSection data-id="element-112" />
      <IncludesSection data-id="element-113" />
      <BenefitsSection data-id="element-114" />
      <PreviewCarouselSection data-id="element-115" />
      <BonusSection data-id="element-116" />
      <PricingSection data-id="element-117" />
      <TestimonialsSection data-id="element-118" />
      <FAQSection data-id="element-119" />

      <footer className="bg-[#1e3a5a] text-white py-8 text-center text-sm" data-id="element-120">
        <div className="max-w-7xl mx-auto px-4" data-id="element-121">
          <p data-id="element-122">
            &copy; {new Date().getFullYear()} Política y Ciudadanía 360. Todos
            los derechos reservados.
          </p>
          <p className="mt-2 text-blue-300" data-id="element-123">
            Diseñado para docentes argentinos.
          </p>
        </div>
      </footer>

      <PurchasePopup data-id="element-124" />
    </main>;
}